import { Experiments } from 'constants/experiments'
import SocialProofDialog from 'components/OfferPage/SocialProofDialog'
import { SOCIAL_PROOF_COPY_VARIANTS } from 'hooks/OfferPage/useSocialProofPopup'

interface Props {
  offer: App.TourOffer
}

function FlashTourSocialProofDialog({ offer }: Props) {
  return (
    <SocialProofDialog
      copyVariant={SOCIAL_PROOF_COPY_VARIANTS.tour}
      experiment={Experiments.croSocialProofTours}
      offerImage={offer.image}
      recentPurchases={offer.stats?.recentPurchases}
    />
  )
}

export default FlashTourSocialProofDialog
